import Ajax from './base'
import endpoints from './endpoints'

const carePlan = {
  verifyMedicationCode: (payload) => {
    const route = endpoints.VERIFY_MEDICATION_CODE
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
    })
  },

  getStateList: (payload, params = {}) => {
    const queryString = new URLSearchParams(params).toString()
    const route = queryString
      ? `${endpoints.GET_STATE_LIST}?${queryString}`
      : endpoints.GET_STATE_LIST
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
    })
  },

  getCityListByStateId: (payload) => {
    const route = endpoints.GET_CITY_LIST_BY_STATE_ID
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
    })
  },

  // Get Doctor's City List
  getDoctorCityList: (payload) => {
    const route = endpoints.GET_DOCTOR_CITY_LIST
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
    })
  },

  getHospitalsInCityList: (payload) => {
    const route = endpoints.GET_HOSPITALS_IN_CITY_LIST
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
    })
  },

  getDoctorsListInHospitalList: (payload) => {
    const route = endpoints.GET_DOCTORS_LIST_IN_HOSPITAL_LIST
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
    })
  },

  addDoctor: (payload) => {
    const route = endpoints.ADD_DOCTOR
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
    })
  },

  addHospital: (payload) => {
    const route = endpoints.ADD_HOSPITAL
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
    })
  },
}

export default carePlan
